/**
 * Cụm nút thao tác của drawer có tab (vd "Vô hiệu hoá" + "…") — desktop nằm cuối thanh tab (`tabBarExtraContent`),
 * ĐIỆN THOẠI (≤767px) xuống HÀNG RIÊNG ngay dưới thanh tab, canh phải (Figma SP-005 responsive `26:44527` nội bộ,
 * `26:44618` đối tác).
 *
 * 🔴 KHÔNG để cụm nút trong `tabBarExtraContent` rồi ép xuống hàng bằng CSS: antd tính vùng hiện tab = bề rộng thanh tab
 * TRỪ bề rộng extra; extra chiếm cả hàng ⇒ vùng tab "rộng 0" và antd dịch hết tab ra ngoài màn (hàng tab trống trơn — lỗi
 * drawer Đối tác 19/09/2026). Để chung hàng thì tab bị ép, chữ bị cắt. Ở hàng riêng, thanh tab giữ nguyên cơ chế cuộn của
 * antd: tự cuộn tab đang chọn vào tầm nhìn, vuốt để xem tab khác.
 *
 * Rải thẳng vào `<Tabs {...drawerTabActionsProps(actions, isMobile)}>`; `actions` rỗng (`null`/`false`) ⇒ không có cụm nút.
 * SCSS của hàng nút ở `styles/common/_common.scss` (`.drawer-tab-actions`).
 */
import React from 'react'
import type { ReactNode } from 'react'
import type { TabsProps } from 'antd'

export const DRAWER_TAB_ACTIONS_CLASS = 'drawer-tab-actions'

export const drawerTabActionsProps = (
  actions: ReactNode,
  isMobile: boolean,
): Pick<TabsProps, 'tabBarExtraContent' | 'renderTabBar'> => {
  if (actions === null || actions === undefined || actions === false) {
    return { tabBarExtraContent: undefined, renderTabBar: undefined }
  }
  if (!isMobile) return { tabBarExtraContent: actions, renderTabBar: undefined }
  return {
    tabBarExtraContent: undefined,
    renderTabBar: (tabBarProps, DefaultTabBar) => (
      <>
        <DefaultTabBar {...tabBarProps} />
        <div className={DRAWER_TAB_ACTIONS_CLASS}>{actions}</div>
      </>
    ),
  }
}
